import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../Services/api-service';
import { ApiResponse } from '../../models/api-response';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-confirm-mail-callback',
  imports: [
    CommonModule,
    TranslatePipe
  ],
  templateUrl: './confirm-mail-callback.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './confirm-mail-callback.scss'
})
export class ConfirmMailCallback {
  private readonly route = inject(ActivatedRoute);
  private readonly apiService = inject(ApiService);
  constructor() {
    const userId = this.route.snapshot.queryParamMap.get('userId');
    const code = this.route.snapshot.queryParamMap.get('code');
    const webDomainEncoded = this.route.snapshot.queryParamMap.get('wd');
    if (userId && code && webDomainEncoded) {
      const decodedDomain = this.decodeBase64(webDomainEncoded);
      this.webDomain.set(decodedDomain);
      this.loading.set(true);
      this.apiService.confirmMailPost({ UserId: userId, Code: code }, decodedDomain).subscribe({
        next: (response: ApiResponse) => {
          if (response.isSuccess) {
            this.success.set(true);
          } else {
            this.success.set(false);
            this.errorMessage.set(response.messages && response.messages.length ? response.messages[0] : '');
          }
          this.loading.set(false);
        },
        error: () => {
          this.success.set(false);
          this.loading.set(false);
          this.errorMessage.set('error');
        }
      });
    } else {
      this.success.set(false);
      this.errorMessage.set('missing_params');
    }
  }

  webDomain = signal<string>(environment.defaultLang);
  success = signal<boolean | null>(null);
  loading = signal<boolean>(false);
  errorMessage = signal<string>(environment.defaultLang);

  private decodeBase64(encoded: string): string {
    try {
      // atob is available in browser environments and decodes base64 to a binary string
      return atob(encoded);
    } catch {
      // return the original value if decoding fails
      return encoded;
    }
  }
}
